<template>
  <div class="form-field">
    <label>{{ data.name }}</label>
    <div class="content">
      <el-input
        class="form-input"
        size="mini"
        :value="data.value"
        @input="updateValue($event)"
      />
      <el-checkbox :value="isDynamic" @input="changeDynamic">动态</el-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
  computed: {
    isDynamic() {
      return (
        this.$store.state.slots.findIndex(
          item => item.name === '##' + this.data.name
        ) >= 0
      );
    }
  },
  methods: {
    updateValue(value) {
      this.$store.commit('update_ae_elm', {
        name: this.data.name,
        value: value
      });
    },
    changeDynamic(v) {
      this.$store.commit('update_ae_dynamic', {
        name: this.data.name,
        isDynamic: v
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.form-field {
  > label {
    padding-right: 10px;
  }
}

.content {
  display: flex;
  padding-right: 20px;
  > div {
    flex: 1;
    margin-right: 10px;
  }
  :global(input) {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 10px;
  }
}
</style>
